import React, { ReactElement } from 'react'

/**
 * Prevents FullStory from recording sensitive content by cloning the element and adding fs-mask
 * class.
 * @param Component React element to wrap with FullStory mask
 * @returns The cloned element with masking applied
 */
export const withFullStoryMask = (Component: ReactElement) =>
  React.cloneElement(Component, {
    className: Component.props.className ? `${Component.props.className} fs-mask` : 'fs-mask',
  })
